import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/therapy";
import { createSignal } from "solid-js";

export default function useCheckupTherapy(props) {

  const [therapies, setTherapies] = createSignal([]);
  const [statuses, setStatuses] = createSignal([
    {
      value: "in progress",
      text: "In Progress",
    },
    {
      value: "completed",
      text: "Completed",
    },
    {
      value: "abandoned",
      text: "Abandoned",
    },
  ]);

  const [therapyForm, setTherapyForm] = createStore({
    therapies: props.therapies || [],
    therapyId: null,
  });

  const { successToast, errorToast } = useApplication();

  const addTherapy = () => {
    if (!therapyForm.therapyId) {
      errorToast("Please select a therapy");
      return;
    }

    const exist = therapyForm.therapies.find(therapy => therapy.therapyId === therapyForm.therapyId);
    if (exist) {
      errorToast("Therapy already added");
      return;
    }

    const therapy = therapies().find(therapy => therapy.value === therapyForm.therapyId);
    if (!therapy) {
      errorToast("Therapy not found");
      return;
    }

    setTherapyForm('therapies', [...therapyForm.therapies, {
      key: crypto.randomUUID(),
      uid: null,
      therapyId: therapyForm.therapyId,
      status: "new",
      name: therapy.text,
    }]);

    therapyForm.therapyId = null;
  }

  const updateTherapyStatus = (key, status) => {
    setTherapyForm('therapies', therapy => therapy.key === key, 'status', status);
  }

  const removeTherapy = (key) => {
    setTherapyForm('therapies', therapyForm.therapies.filter(therapy => therapy.key !== key));
  }

  const onFetchTherapies = async () => {
    try {
      const data = await list();
      setTherapies(data.list || []);
    } catch(error) {
      setTherapies([]);
    }
  }

  const onSaveTherapy = async () => {

    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('therapies', JSON.stringify(therapyForm.therapies));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Therapy saved successfully");
      } else {
        errorToast(data.message || "Failed to save therapy");
      }
    } catch(error) {
      errorToast("Failed to save therapy");
    } finally {
      props.setLoading(false);
    }
  }

  const handleTherapyInput = (name, value) => {
    setTherapyForm([name], value);
  };

  return {
    therapies,
    therapyForm,
    onSaveTherapy,
    handleTherapyInput,
    onFetchTherapies,
    statuses,
    addTherapy,
    removeTherapy,
    updateTherapyStatus,
  };
}
